import { render, staticRenderFns } from "./BePartner.vue?vue&type=template&id=72aa654a&scoped=true&"
import script from "./BePartner.vue?vue&type=script&lang=js&"
export * from "./BePartner.vue?vue&type=script&lang=js&"
import style0 from "./BePartner.vue?vue&type=style&index=0&id=72aa654a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa654a",
  null
  
)

export default component.exports